import * as React from 'react';
import { initialAuthStateLite, initialAuthStatePublic } from './auth-state';
import type { AuthContextInterface } from './types';

const stub = (): never => {
  throw new Error('You forgot to wrap your component in <AuthProvider>.');
};

export const initialContext = {
  ...initialAuthStatePublic,
  ...initialAuthStateLite,
  isLoading: initialAuthStateLite.isLoading || initialAuthStatePublic.isLoading,
  loginWithRedirect: stub,
  loginWithQuuidRedirect: stub,
  runForcedRedirect: stub,
  getForcedAuthVariants: stub,
  sendAuthSuccessEvent: stub,
  sendTokenReceivedEvent: stub,
  openPersonalAccountCards: stub,
  getUserInfo: stub,
  loginWithPopup: stub,
  loginWithNewTab: stub,
  logout: stub,
  revoke: stub,
  refreshToken: stub,
  getWidget: stub,
  getTokenManually: stub,
  changeConfigData: stub,
  refreshSdkConfigFromServer: (): Promise<void> => Promise.reject(new Error('You forgot to wrap your component in <AuthProvider>.')),
  setScore: stub,
  setUserInfo: stub,
  logoutLite: stub,
  signIn: stub,
  loginWithOtp: stub,
};

/**
 * The Auth Context
 */
export const AuthContext = React.createContext<AuthContextInterface>(
  initialContext,
);
